import React from "react";
import {
  Workspaces,
  Badge,
  Architecture,
  AutoAwesomeMosaic,
  Group,
  Policy,
  PresentToAll,
  PrivacyTip,
  RemoveFromQueue,
  PeopleAlt,
  AccountBalanceWallet,
  CreditCard,
  Sell,
  PersonAddAlt,
  Groups,
  ModeStandby,
  DateRange,
  AllInclusive,
  People,
  NoAccounts,
  SettingsAccessibility,
} from "@mui/icons-material";

export const leaveTypeHeader = [
  { name: "Leave Type", key: "name" },
  { name: "Color Code", key: "leave_color" },
  { name: "No of Configurations", key: "no_of_configuration" },
  { name: "Actions", key: "action" },
];
export const viewLeaveTypeDetails = [
  {
    name: "Version",
    key: "version",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
  {
    name: "Proportions Leaves on join date",
    key: "proportionate_leaves_on_joined_date",
  },
  {
    name: "Is This Leave type paid",
    key: "is_paid_leave",
  },
  {
    name: "Payment Factor",
    key: "payment_factor",
  },
  {
    name: "Leave Crediting Schedule",
    key: "leave_crediting_schedule",
  },
  {
    name: "Leave Per Leave Period",
    key: "leave_per_leave_period",
  },
  {
    name: "Leave Payout Policy",
    key: "leave_pay_out_policy",
  },
  {
    name: "Carryforward Days",
    key: "no_of_days_leave_carry_forward",
  },
  {
    name: "Duration in Month",
    key: "expiry_month",
  },
  {
    name: "Last Credited Date",
    key: "last_credited_date",
  },
  {
    name: "Action",
    key: "action",
  },
];

export const scheduleMultiplier = {
  Annually: 1,
  Quarterly: 4,
  "Half Yearly": 2,
  Monthly: 12,
};

export const monthNumber = [
  { label: "1" },
  { label: "2" },
  { label: "3" },
  { label: "4" },
  { label: "5" },
  { label: "6" },
  { label: "7" },
  { label: "8" },
  { label: "9" },
  { label: "10" },
  { label: "11" },
  { label: "12" },
];

export const assignHeader = [
  {
    name: "",
    key: "check_box",
  },
  {
    name: "",
    key: "arrow_down",
  },
  {
    name: "Employee Id",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Leave Group",
    key: "leave_group_name",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
  {
    name: "Action",
    key: "",
  },
];

export const individualAssignHeader = [
  {
    name: "Employee Id",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Leave Group",
    key: "leave_group_name",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
  // {
  //   name: "Action",
  //   key: "",
  // },
];

export const individualLeaveGroupDetails = [
  {
    name: "Leave Type",
    key: "leave_type_name",
  },
  {
    name: "Annual Allowance",
    key: "annual_allowance",
  },
  {
    name: "Total Credited",
    key: "credited_leave",
  },
  {
    name: "Total Planned",
    key: "planned_leave",
  },
  {
    name: "Taken Leave",
    key: "used_leave",
  },
  {
    name: "Balance",
    key: "available_leave",
  },
  {
    name: "Expiry Date",
    key: "expiry_date",
  },
];

export const salaryComponentHeader = [
  {
    name: "Name",
    key: "name",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Category",
    key: "component_category",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Code",
    key: "code",
    type: "autocomplete",
    icon: <Architecture fontSize="small" />,
  },
  {
    name: "Method",
    key: "computation_method",
    type: "autocomplete",
    icon: <AutoAwesomeMosaic fontSize="small" />,
  },
  {
    name: "Employees",
    key: "employee_count",
    type: "number",
    icon: <Group fontSize="small" />,
  },
  {
    name: "Gross",
    key: "include_in_gross",
    type: "boolean",
    icon: <RemoveFromQueue fontSize="small" />,
  },
  {
    name: "CTC",
    key: "include_in_ctc",
    type: "boolean",
    icon: <Policy fontSize="small" />,
  },
  {
    name: "TDS",
    key: "include_in_tds",
    type: "boolean",
    icon: <PresentToAll fontSize="small" />,
  },
  {
    name: "Show in payslip",
    key: "show_in_payslip",
    type: "boolean",
    icon: <PrivacyTip fontSize="small" />,
  },
];

export const salaryTempateHeader = [
  {
    name: "Name",
    key: "template_name",
    type: "autocomplete",
    icon: <PeopleAlt fontSize="small" />,
  },
  {
    name: "Salary Type",
    key: "salary_type",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Employee Count",
    key: "employee_count",
    type: "number",
    icon: <AccountBalanceWallet fontSize="small" />,
  },
  {
    name: "Gross Salary",
    key: "salary",
    type: "number",
    icon: <CreditCard fontSize="small" />,
  },

  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <Sell fontSize="small" />,
  },
];

export const componentGroupViewHeader = [
  {
    name: "",
    key: "Action",
  },
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "No of Employees",
    key: "employee_count",
    type: "number",
    icon: <PersonAddAlt fontSize="small" />,
  },
  // {
  //   name: "View",
  //   key: "view",
  //   Viewmode: true,
  //   icon: <Visibility fontSize="small" />,
  // },
];

export const IndividualUserComponentHeader = [
  {
    name: "Employee ID",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "user_name",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Designation",
    key: "designation",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
];

export const componentEmployeeViewHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Employee id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },

  {
    name: "Department",
    key: "department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },

  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Effective To",
    key: "effective_to",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
];

export const templateGroupViewHeader = [
  {
    name: "",
    key: "Action",
  },
  {
    name: "Template Name",
    key: "template_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "No of Employees",
    key: "total_employees",
    type: "number",
    icon: <People fontSize="small" />,
  },
  {
    name: "Non-Override Employee",
    key: "non_override",
    type: "number",
    icon: <SettingsAccessibility fontSize="small" />,
  },
  {
    name: "Override Employee",
    key: "override",
    type: "number",
    icon: <NoAccounts fontSize="small" />,
  },
];

export const templateEmployeeViewHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Employee id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },

  {
    name: "Department",
    key: "department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },

  {
    name: "Template Name",
    key: "template_name",
    type: "string",
    icon: <AllInclusive fontSize="small" />,
  },

  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Effective To",
    key: "effective_to",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
];

export const templateLogHeader = [
  {
    name: "Template Name",
    key: "template_name",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
];



export const structure = [
  {
    revision: {
      revision_id: 16,
      user_id: 437,
      employee_name: "A Chitra",
      revision_based_on: "Employee",
      selection_based_on: "Department",
      reason: "Individual promotion",
      applicable_for: "Override Employee",
      created_at: "2026-01-13T04:12:38.253758Z",
      template_id: null,
      template_name: null,
      department_id: 1,
      department_name: "General",
      previous_template_id: 2,
      total_employee_count: 5,
      override_count: 4,
      non_override_count: 1,
    },
    previous_structure: {
      structure_id: 277,
      effective_from: "2026-01-02",
      effective_to: "2025-01-02",
      salary: 30000.0,
      version: 3,
      template_id: 2,
      template_name: "Monthly Salary 20000",
      salary_type: "Monthly",
      salary_basis: "Gross",
      total_ctc: 20000.0,
      components: [
        {
          component_id: 1,
          component_name: "Special Allowance",
          component_code: "SP",
          component_type: "System",
          computation_method: "Formula",
          computation_value: "GROSS - BASIC",
          amount: null,
        },
        {
          component_id: 2,
          component_name: "Basic",
          component_code: "BASIC",
          component_type: "System",
          computation_method: "Percentage",
          computation_value: "100% of GROSS",
          amount: 20000.0,
        },
      ],
    },
    new_structure: {
      structure_id: 278,
      effective_from: "2026-01-03",
      effective_to: null,
      salary: 30000.0,
      version: 4,
      template_id: 3,
      template_name: "Test template",
      salary_type: "Monthly",
      salary_basis: "Gross",
      total_ctc: 25000.0,
      components: [
        {
          component_id: 1,
          component_name: "Special Allowance",
          component_code: "SP",
          component_type: "System",
          computation_method: "Formula",
          computation_value: "GROSS - BASIC",
          amount: null,
        },
      ],
    },
  },
];